import { cn } from "@/lib/utils";

interface OgmaLogoProps {
  size?: number;
  className?: string;
}

export function OgmaLogo({ size = 48, className }: OgmaLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1700 2000"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-foreground", className)}
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M866.25,478.205l414.138,-239.103l452.112,261.028l0,1000.26l-866.25,500.13l0,-478.585l0,-0c0,-0 451.783,-260.837 451.783,-260.837c0,-0 0,-521.675 0,-521.675l-451.783,-260.837l0,0c-136.699,78.923 -315.084,181.914 -451.783,260.837c0,0 0,521.675 0,521.675l451.084,260.434l-414.467,239.292l-451.084,-260.434l0,-1000.26l866.25,-500.13l0,478.205Z"
      />
    </svg>
  );
}
